import {
  BacsModal,
  BankSelect,
  Collapse,
  CollapseItem,
  MerchantButton,
  StripePayment,
  AdyenPayment,
} from "@components";
import { formatAmount } from "@utils";
import { useRef, useState } from "react";
import { Oval } from "react-loader-spinner";

const PaymentMethodSelect = ({
  bacs = true,
  merchant,
  paymentParameters,
  processingUrl,
  successUrl,
  onPayByBankSelected,
  paymentError,
}) => {
  const [method, setMethod] = useState(
    paymentError === "bank-error" ? "paybybank" : null
  );
  const [institution, setInstitution] = useState(null);
  const [processing, setProcessing] = useState(false);
  const stripeRef = useRef(null);
  const adyenRef = useRef(null);

  // OB payment handline
  //error

  const continuePayment = () => {
    setProcessing(true);

    if (method === "paybybank") {
      onPayByBankSelected(institution);
    }

    if (method === "card") {
      if (paymentParameters.cardPaymentProvider === "Stripe") {
        stripeRef.current?.submitPayment();
      } else if (paymentParameters.cardPaymentProvider === "Adyen") {
        adyenRef.current?.submitPayment();
      } else {
        console.error(
          "Unknown cardPaymentProvider: " +
            paymentParameters.cardPaymentProvider
        );
      }
    }
  };

  const onStripeError = () => {
    setProcessing(false); // Stop processing if Stripe returns an error
  };

  const onAdyenError = () => {
    setProcessing(false); // Stop processing if Adyen returns an error
  };

  return (
    <div
      id="payment-area"
      className="lg:pl-20 lg:pt-12 flex flex-col px-5 lg:px-0"
    >
      <div className="lg:w-[440px] lg:px-0">
        <div className="mt-8 mb-5">
          <h3 className="text-lg font-semibold">Select payment method</h3>
          <h4 className="text-sm text-zinc-500">
            All transactions are secure and encrypted
          </h4>
        </div>
        <Collapse>
          <CollapseItem
            top
            label="Pay by bank"
            isOpen={method === "paybybank"}
            onClick={() => setMethod("paybybank")}
          >
            <BankSelect
              onSelect={setInstitution}
              error={paymentError === "bank-error"}
            />
          </CollapseItem>
          {paymentParameters?.cardPaymentAllowed && (
            <CollapseItem
              bottom
              label="Pay by card"
              isOpen={method === "card"}
              onClick={() => setMethod("card")}
            >
              {paymentParameters.cardPaymentProvider === "Stripe" && (
                <StripePayment
                  paymentParameters={paymentParameters}
                  stripeAccountId={merchant.stripeId}
                  externalSubmitRef={stripeRef}
                  returnUrl={processingUrl}
                  onError={onStripeError}
                />
              )}
              {paymentParameters.cardPaymentProvider === "Adyen" && (
                <AdyenPayment
                  paymentParameters={paymentParameters}
                  stripeAccountId={merchant.stripeId}
                  externalSubmitRef={adyenRef}
                  processingUrl={processingUrl}
                  successUrl={successUrl}
                  onError={onAdyenError}
                />
              )}
            </CollapseItem>
          )}
        </Collapse>
        {bacs && (
          <BacsModal
            merchant={merchant}
            reference={paymentParameters.reference}
          />
        )}
        <MerchantButton
          merchant={merchant}
          disabled={
            processing || !method || (method === "paybybank" && !institution)
          }
          onClick={continuePayment}
          className="my-4 flex items-center justify-center gap-2"
        >
          {method !== "paybybank" &&
            `Pay ${formatAmount(paymentParameters.amount)}`}
          {method === "paybybank" && "Confirm and continue"}
          {processing && (
            <Oval
              color="white"
              className="inline ml-2"
              width={16}
              height={16}
              strokeWidth={6}
            />
          )}
        </MerchantButton>
      </div>
    </div>
  );
};
export default PaymentMethodSelect;
